import { Divider, Stack } from "@mantine/core"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { WebCalendarProfileDto } from "../../../../../@client/Theasoft_Shared_Contracts_WebCalendar"
import { CalendarProfileStackItem } from "./calendar-profile-stack-item"
import { useTranslation } from "react-i18next"

interface Props {
  onEditProfileClick: (profile: WebCalendarProfileDto) => void
}

export function CalendarStack({ onEditProfileClick }: Props) {
  const { t } = useTranslation("app_server")
  const { data: profiles } = useSuspenseQueryGet(
    "/api/WebCalendar/GetProfiles",
    null
  )

  return (
    <Stack>
      {profiles.personalProfiles.length ? (
        <>
          <Divider label={t("OwnCalendars")} size="xl" labelPosition="left" />
          {profiles.personalProfiles.map((profile, i) => (
            <React.Fragment key={profile.id}>
              {i > 0 && <Divider />}
              <CalendarProfileStackItem
                onEditProfileClick={onEditProfileClick}
                profile={profile}
              />
            </React.Fragment>
          ))}
          <Divider
            label={t("SharedCalendars")}
            size="xl"
            labelPosition="left"
            mt="xl"
          />
        </>
      ) : null}
      {profiles.sharedProfiles.map((profile, i) => (
        <React.Fragment key={profile.id}>
          {i > 0 && <Divider />}
          <CalendarProfileStackItem
            onEditProfileClick={onEditProfileClick}
            profile={profile}
          />
        </React.Fragment>
      ))}
    </Stack>
  )
}
